import { Component } from '@angular/core';

@Component({
    selector: 'app-empty',
    template: '',
    standalone: false
})
export class EmptyComponent {
  constructor() {}
}
